import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { WordSearchList } from '../../components/WordSearch/WordSearchList';
import { ListControls } from '../../components/UI/ListControls';
import { clearError, setActiveFilter, } from '../../redux/reducers/word-searches';
import { getWordSearches } from '../../redux/actions/word-searches';
import { getFilteredWordSearches } from '../../redux/selectors/word-searches';
import { utils } from '../../utils/helpers';
const ListWordSearchesComponent = ({ wordSearches, activeFilter, getWordSearches, clearError, setActiveFilter, }) => {
    const [layout, setLayout] = useState(utils.getLocalStorage('wordSearch-list-layout', 'List'));
    const [page, setPage] = useState({
        current: 1,
        size: utils.getLocalStorage('quiz-list-page-size', 5),
    });
    const [visibleWordSearches, setVisibleWordSearches] = useState([]);
    useEffect(() => {
        if (wordSearches.length <= 1)
            getWordSearches({});
        return () => {
            clearError();
        };
    }, []);
    useEffect(() => {
        const startIndex = (page.current - 1) * page.size;
        const endIndex = startIndex + page.size;
        const paginatedQWordSearches = wordSearches.slice(startIndex, endIndex);
        setVisibleWordSearches(paginatedQWordSearches);
    }, [wordSearches, page]);
    const updateLayout = (layout) => {
        const newPageSize = layout === 'Grid'
            ? wordSearches.length
            : utils.getLocalStorage('rossword-list-page-size', 5);
        setPage({ current: 1, size: newPageSize });
        setLayout(layout);
        utils.setLocalStorage('rossword-list-layout', layout);
    };
    const updateFilter = ({ status, text, }) => {
        setActiveFilter({ status, text });
        setPage({ ...page, current: 1 });
    };
    const updatePage = ({ current, size }) => {
        setPage({ current, size });
        // Save page size to localStorage (but not for Grid layout which shows all items)
        if (layout !== 'Grid') {
            utils.setLocalStorage('wordSearch-list-page-size', size);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListControls, { totalLength: wordSearches.length, layout: layout, updateLayout: updateLayout, activeFilter: activeFilter, updateFilter: updateFilter, page: page, updatePage: updatePage }),
        React.createElement(WordSearchList, { wordSearches: visibleWordSearches, layout: layout })));
};
/**
 * Maps Redux state to component props
 */
const mapStateToProps = (state) => ({
    wordSearches: getFilteredWordSearches(state.wordSearchState.wordSearches, state.wordSearchState.activeFilter),
    activeFilter: state.wordSearchState.activeFilter,
    loading: state.wordSearchState.loading,
    error: state.wordSearchState.error,
    errorDetail: state.wordSearchState.errorDetail,
});
/**
 * Redux action creators to be bound to component props
 */
const mapDispatchToProps = {
    getWordSearches,
    clearError,
    setActiveFilter,
};
export const ListWordSearches = connect(mapStateToProps, mapDispatchToProps)(ListWordSearchesComponent);
